import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import Questionnaire from "@/pages/Questionnaire";
import Plan from "@/pages/Plan";
import Shop from "@/pages/Shop";
import Product from "@/pages/Product";
import Cart from "@/pages/Cart";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import Dashboard from "@/pages/Dashboard";
import CoachChat from "@/pages/CoachChat";
import NutritionTracker from "@/pages/NutritionTracker";
import WorkoutTracker from "@/pages/WorkoutTracker";
import Legal from "@/pages/Legal";
import Pricing from "@/pages/Pricing";
import ComingSoon from "@/pages/ComingSoon";

export default function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <Toaster
            position="top-right"
            theme="dark"
            toastOptions={{
              style: {
                background: "#0a0a0a",
                border: "1px solid rgba(255,255,255,0.1)",
                color: "#fff",
                fontFamily: "Rajdhani, sans-serif",
                letterSpacing: "0.02em",
              },
            }}
          />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Landing />} />
              <Route path="/shop" element={<ComingSoon />} />
              <Route path="/coming-soon" element={<ComingSoon />} />
              <Route path="/product/:id" element={<ComingSoon />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/questionnaire" element={<Questionnaire />} />
              <Route path="/plan/:id" element={<Plan />} />
              <Route path="/plan/:id/chat" element={<CoachChat />} />
              <Route path="/track/nutrition" element={<NutritionTracker />} />
              <Route path="/track/workouts" element={<WorkoutTracker />} />
              <Route path="/legal" element={<Legal />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/checkout/success" element={<CheckoutSuccess />} />
              <Route path="/dashboard" element={<Dashboard />} />
            </Route>
            <Route path="/auth" element={<Auth />} />
          </Routes>
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}
